'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Group = undefined;

var _systemComponents = require('system-components');

var _systemComponents2 = _interopRequireDefault(_systemComponents);

var _gridStyled = require('grid-styled');

var _styledSystem = require('styled-system');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Group = exports.Group = (0, _systemComponents2.default)({
  is: _gridStyled.Flex
}, function (props) {
  var radius = (0, _styledSystem.theme)('radii.2', 4)(props) + 'px';
  return {
    '& > *': {
      borderRadius: 0
    },
    '& > *:first-child': {
      borderRadius: radius + ' 0 0 ' + radius

    },
    '& > *:last-child': {
      borderRadius: '0 ' + radius + ' ' + radius + ' 0'
    }
  };
});

Group.displayName = 'Group';

exports.default = Group;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rebass/dist/Group.js
// module id = 278
// module chunks = 0